import { __assign, __rest } from "tslib";
import React from 'react';
import { FunnelChart, theme as defaultTheme, } from '@keen.io/charts';
import WidgetHeading from '../widget-heading.component';
import ChartWidget from '../chart-widget';
import { Content } from './funnel-chart.widget.styles';
import { legendSettings } from '../../widget-settings';
export var FunnelChartWidget = function (_a) {
    var _b = _a.legend, legend = _b === void 0 ? legendSettings : _b, _c = _a.theme, theme = _c === void 0 ? defaultTheme : _c, title = _a.title, subtitle = _a.subtitle, card = _a.card, tags = _a.tags, props = __rest(_a, ["legend", "theme", "title", "subtitle", "card", "tags"]);
    return (React.createElement(ChartWidget, { cardSettings: card, legendSettings: {
            position: legend.position,
            alignment: legend.alignment,
            layout: legend.layout,
        }, title: function () { return (React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags })); }, legend: function () { return null; }, content: function () { return (React.createElement(Content, null,
            React.createElement(FunnelChart, __assign({ theme: theme }, props)))); } }));
};
export default FunnelChartWidget;
